import { GrCirclePlay } from "react-icons/gr";

import "@/styles/components/screen/connect-screen.css"
import { StreamingStateEnum } from "@/data/webrtc-enums";

export interface ConnectScreenProps {
    onConnectClick?: () => void,
    streamingState?: StreamingStateEnum,
    errorMessage?: string | null,
    statusMessage?: string | null,
    isStarting?: boolean
}

export const ConnectScreen: React.FC<ConnectScreenProps> = ({ 
    onConnectClick, 
    streamingState,
    errorMessage,
    statusMessage,
    isStarting
}) => {

    const isBusy = isStarting || streamingState !== StreamingStateEnum.WebRtcDisconnected;
    const clickable = !isBusy;

    return (
        <div className="absolute ctn-full bg-connect-screen z-100">
            <div className="absolute ctn-full ctn-center flex-col gap-4"
                 onClick={clickable ? onConnectClick : undefined}
                 style={{ cursor: clickable ? 'pointer' : 'default' }}
            >
                {isBusy ? (
                    <div className="w-[100px] ctn-center">
                        <div className="dot-carousel"></div>
                    </div>
                ) : (
                    <GrCirclePlay className="w-[50px] h-[50px]" />
                )}

                {(statusMessage || isBusy) && (
                    <div style={{
                        color: 'rgba(255, 255, 255, 0.85)',
                        fontSize: '0.95rem',
                        fontWeight: 400,
                        letterSpacing: '0.02em',
                        textAlign: 'center',
                        maxWidth: '360px',
                        padding: '0 16px',
                        marginTop: '8px',
                        minHeight: '1.4em',
                    }}>
                        {statusMessage}
                    </div>
                )}

                {clickable && (
                    <div style={{
                        color: 'rgba(255, 255, 255, 0.7)',
                        fontSize: '1.15rem',
                        marginTop: '8px',
                        lineHeight: '1.6',
                        textAlign: 'center',
                    }}>
                        Click anywhere to start
                        <br />
                        <span style={{ fontSize: '1.05rem', color: 'rgba(255, 255, 255, 0.5)' }}>
                            Klicken Sie irgendwo, um zu starten
                        </span>
                    </div>
                )}
            </div>

            {errorMessage && (
                <div className="error-message" style={{ 
                    color: 'red', 
                    margin: '10px 0', 
                    padding: '10px', 
                    backgroundColor: 'rgba(255, 0, 0, 0.1)',
                    borderRadius: '4px'
                }}>
                    {errorMessage}
                </div>
            )}
        </div>
    );
};